import * as z from "zod";

/** The team's running storefront A/B test, which overrides its coverage settings. */
export const getActiveStorefrontAbTest = {
  name: "getActiveStorefrontAbTest" as const,
  input: z.object({ teamId: z.string() }).strict(),
  output: z.object({ testId: z.string().nullable() }),
};
